export default "/images/vendor/flag-icon-css/flags/4x3/cg.svg?05e95e537bcdc02a69a734ed9a343839";